var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCellMolecule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "144.19 117.21 144.19 77.78 110.35 58.06 76.52 77.78 76.52 117.21 110.35 136.92 144.19 117.21"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 178.06,
    y1: 138.24,
    x2: 144.71,
    y2: 119.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 178.07,
    y1: 57.27,
    x2: 145.3,
    y2: 77.25
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "109.47 175.94 109.47 136.51 75.63 116.8 41.79 136.51 41.79 175.94 75.63 195.66 109.47 175.94"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 110.77,
    y1: 57.78,
    x2: 110.77,
    y2: 21.85
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCellMolecule);
export default __webpack_public_path__ + "static/media/CELL_MOLECULE.4e93305983b8e66ff563efcdf750d396.svg";
export { ForwardRef as ReactComponent };